import apiService from 'shared/services/api';

export const deletePlace = (id) => apiService({}).delete(`/places/${id}`);
